import { IVideoType } from '@components/typescript';
import getCurrentDevice from '@utils/getCurrentDevice';
import isVideoUrl from '@utils/isVideoUrl';
import { TResponsiveType } from '@features/responsive/typescript';
const getVideoUrl = (video: IVideoType | string, breakpoint: TResponsiveType | undefined) => {
  let videoLink = '';
  const currentDevice = getCurrentDevice(breakpoint);
  if (typeof video === 'string') {
    if (video.includes('http')) {
      videoLink = isVideoUrl(video) ? video : '';
    } else {
      videoLink = `https://www.youtube.com/embed/${video}`;
    }
    return videoLink;
  }
  if (video[currentDevice]) {
    const currentVideo = video[currentDevice];
    if (typeof currentVideo === 'string') {
      if (isVideoUrl(currentVideo)) {
        videoLink = currentVideo;
      }
    } else if (currentVideo.type === 'youtube') {
      videoLink = `https://www.youtube.com/embed/${currentVideo.data}`;
    } else if (currentVideo.data && isVideoUrl(currentVideo.data)) {
      videoLink = currentVideo.data;
    }
  }
  return videoLink;
};
export default getVideoUrl;